import gsap from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(DrawSVGPlugin, MotionPathPlugin);

const infiniteSvg = () => {
  const line3 = document.querySelector(".js-svg-load-main path");
  if (!line3) {
    return;
  }
  const line1 = splitPaths(document.querySelector(".js-svg-load-1 path"));
  const line2 = splitPaths(document.querySelector(".js-svg-load-2 path"));
  const arrow1 = document.querySelector(".js-line-arrow-1");
  const arrow2 = document.querySelector(".js-line-arrow-2");

  let t1 = gsap.timeline({
    repeat: -1,
  });
  t1.from(arrow1, {
    opacity: 0,
  })
    .from(line1, {
      drawSVG: 0,
      duration: 0.6,
    })

    .from(arrow2, {
      opacity: 0,
    })
    .from(line2, {
      drawSVG: 0,
      duration: 0.6,
    })

    .to(
      line1,
      {
        opacity: 0,
      },
      "start"
    )
    .to(
      arrow1,
      {
        opacity: 0,
      },
      "start"
    )
    .to(
      line2,
      {
        opacity: 0,
      },
      "start"
    )
    .to(
      arrow2,
      {
        opacity: 0,
      },
      "start"
    );

  gsap.from(line3, {
    opacity: 0,
    duration: 0.7,
    delay: 1.2,
  });

  function splitPaths(paths) {
    let toSplit = gsap.utils.toArray(paths),
      newPaths = [];
    if (toSplit.length > 1) {
      toSplit.forEach((path) => newPaths.push(...splitPaths(path)));
    } else {
      let path = toSplit[0],
        rawPath = MotionPathPlugin.getRawPath(path),
        parent = path.parentNode,
        attributes = [].slice.call(path.attributes);
      newPaths = rawPath.map((segment) => {
        let newPath = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path"
          ),
          i = attributes.length;
        while (i--) {
          newPath.setAttributeNS(
            null,
            attributes[i].nodeName,
            attributes[i].nodeValue
          );
        }
        newPath.setAttributeNS(
          null,
          "d",
          "M" +
            segment[0] +
            "," +
            segment[1] +
            "C" +
            segment.slice(2).join(",") +
            (segment.closed ? "z" : "")
        );
        parent.insertBefore(newPath, path);
        return newPath;
      });
      parent.removeChild(path);
    }
    return newPaths;
  }
};

export default infiniteSvg;
